import { AuthForm, AuthFormProps } from "./AuthForm";
import React from "react";
import { SaveDataByStep } from "./SaveDataByStep";
import { AuthSkeleton } from "./AuthSkeleton";
import { PickAccountType } from "./PickAccountType";

interface Props extends AuthFormProps {
  readonly authStage: "auth" | "registration" | "pickAccountType";
  readonly availableAccountTypes?: Auth.AvailableAccountTypes[];
  readonly onSelectAccountType: (accountType: Auth.AvailableAccountTypes) => Promise<void>;
  readonly onBackToAuth: () => void;
}

export function AuthSidebar(props: Props) {
  if (props.authStage === "auth") {
    return (
      <AuthSkeleton
        title={"Вход или регистрация в личном кабинете"}
        content={<AuthForm {...props} />}
      />
    );
  }

  if (props.authStage === "registration") {
    return (
      <AuthSkeleton
        isShowTitle={false}
        content={<SaveDataByStep resetPhone={() => props.setPhone(undefined)} />}
      />
    );
  }

  if (props.authStage === "pickAccountType") {
    return (
      <AuthSkeleton
        isShowTitle={false}
        content={
          <PickAccountType
            availableAccountTypes={props.availableAccountTypes || []}
            onSelect={props.onSelectAccountType}
            onBackClick={props.onBackToAuth}
          />
        }
      />
    );
  }

  return null;
}
